import { Stack } from '@/components/layout';
import { Button, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { AuthView } from '@/features/auth/components';
import { useVerifyEmail } from '@/features/auth/hooks/use-verify-email';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

export function VerifyEmailScreen() {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const { handleSendVerificationEmail, handleCancel } = useVerifyEmail();

  return (
    <AuthView>
      <AuthView.Content>
        <Stack
          width="100%"
          paddingX={scale({ phone: 16, tablet: 40 })}
          paddingTop={scale({ phone: 36, tablet: 30 })}
          gap={scale(10)}>
          <Text
            variant={
              isTablet
                ? 'Font Inter/Body/Bold 16px'
                : 'Font Montserrat/Subtitle/Subtitle 2 Bold 12px'
            }
            style={styles.title}
            transform="uppercase">
            {STRINGS.auth.verifyEmail.title}
          </Text>
          <Text
            variant={
              isTablet ? 'Font Inter/Subtitle/Regular 14px' : 'Font Inter/Subtitle/Regular 11px'
            }
            style={styles.description}>
            {STRINGS.auth.verifyEmail.description}
          </Text>
        </Stack>

        <Stack flex={1} />

        <Stack
          width="100%"
          paddingX={scale({ phone: 16, tablet: 40 })}
          gap={scale(16)}
          align="center">
          <Button onPress={handleSendVerificationEmail} style={styles.button}>
            <Button.Text>{STRINGS.auth.verifyEmail.buttonSendVerificationEmail}</Button.Text>
          </Button>

          <Button variant="outline" onPress={handleCancel} style={styles.button}>
            <Button.Text transform="uppercase">{STRINGS.auth.verifyEmail.buttonCancel}</Button.Text>
          </Button>
        </Stack>

        <Stack flex={1} />

        <Stack align="center" gap={scale(4)}>
          <AuthView.Logo />
        </Stack>
      </AuthView.Content>
    </AuthView>
  );
}

const useStyles = createStyles(({ scale }) => ({
  title: {
    color: colors.Blue,
  },
  description: {
    color: colors['6'],
  },
  button: {
    width: scale({
      phone: 212,
      tablet: 240,
    }),
  },
}));
